// src/config/menus.js
export const menus = [
  { to: "/", body: ["/"], label: "Homepage", icon: "bi bi-house-door", type: "Home", permission: "Homepage" },
  { to: "/claim-invoice", body: ["/claim-invoice"], label: "Claim Submission", icon: "bi bi-receipt-cutoff", type: "Home", permission: "Claim Submission" },
  { to: "/user", body: ["/user"], label: "User", icon: "bi bi-person", type: "Master Data", permission: "User" },
  { to: "/role-permission", body: ["/role-permission"], label: "Role Permission", icon: "bi bi-person-fill-lock", type: "Master Data", permission: "Role Permission" },
];